module.exports = __webpack_public_path__ + "static/img/kepco-icqcc.8c40395.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/visual-marketing-detail/kepco-icqcc.jpg
// module id = 4Z3F
// module chunks = 0